package org.vreo.devicehub.features.device.presentation.deviceManagement.messages.components

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

import org.vreo.devicehub.features.core.domain.device.message.AnprCameraMessage

/**
 * Message list composable. Displays list of anpr messages.
 *
 * @param messages list of anpr messages to display
 * @param onMessageClick callback for when a message is clicked
 * @param modifier modifier for the composable
 * @param scrollState scroll state for the list
 */
@Composable
fun MessageList(
    messages: List<AnprCameraMessage>,
    onMessageClick: (AnprCameraMessage) -> Unit,
    modifier: Modifier = Modifier,
    scrollState: LazyListState = rememberLazyListState()
) {
    LazyColumn(
        state = scrollState,
        verticalArrangement = Arrangement.spacedBy(8.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
    ) {
        items(messages) { message ->
            MessageListItem(
                message = message,
                onClick = onMessageClick,
                modifier = Modifier
                    .fillParentMaxWidth()
            )

        }
    }
}

@Preview
@Composable
fun MessageListPreview() {
    @OptIn(ExperimentalTime::class)
    val currentMoment: Instant = Clock.System.now()

    @OptIn(ExperimentalTime::class)
    val datetimeInSystemZone: LocalDateTime =
        currentMoment.toLocalDateTime(TimeZone.currentSystemDefault())

    val messageDemoList = mutableListOf<AnprCameraMessage>()
    for (i in 0..10) {
        messageDemoList.add(
            AnprCameraMessage(
                msgId = i.toString(),
                softwareVersion = "1.0.0",
                ocrVersion = "1.0.0",
                vehicleId = 1,
                licensePlate = "abc 123",
                licensePlateWidth = 1,
                licensePlateHeight = 1,
                confidenceScore = 1f,
                ocrAttempt = 1,
                imageUrl = "/example/url",
                date = datetimeInSystemZone,
                timeStamp = 0,
                selected = false
            )
        )
    }

    MessageList(
        messages = messageDemoList,
        onMessageClick = { }
    )
}